(function () {
  window.Shopify = window.Shopify || {};
  Shopify.queryParams = Shopify.queryParams || {};

  if (Object.keys(Shopify.queryParams).length === 0) {
    var search = window.location.search;
    if (search && search.length > 1) {
      var params = search.substring(1).split("&");

      for (var i = 0; i < params.length; i++) {
        if (!params[i]) continue;

        var parts = params[i].split("=");
        var paramName = decodeURIComponent(parts[0] || "");
        var paramValue = decodeURIComponent(parts[1] || "");

        if (paramName) {
          Shopify.queryParams[paramName] = paramValue;
        }
      }
    }
  }

  function buildQueryString(params) {
    var usp = new URLSearchParams();

    Object.keys(params).forEach(function (key) {
      if (params[key] != null && params[key] !== "") {
        usp.set(key, params[key]);
      }
    });

    return usp.toString().replace(/%2B/g, "+");
  }

  function slideDown(panel) {
    if (!panel) return;

    panel.hidden = false;
    panel.style.overflow = "hidden";
    panel.style.maxHeight = "0px";

    var target = panel.scrollHeight;

    requestAnimationFrame(function () {
      panel.style.maxHeight = target + "px";
    });

    var onEnd = function (ev) {
      if (ev.propertyName !== "max-height") return;

      panel.style.maxHeight = "none";
      panel.style.overflow = "visible";
      panel.removeEventListener("transitionend", onEnd);
    };

    panel.addEventListener("transitionend", onEnd);
  }

  function slideUp(panel) {
    if (!panel) return;

    panel.style.overflow = "hidden";

    if (!panel.style.maxHeight || panel.style.maxHeight === "none") {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }

    requestAnimationFrame(function () {
      panel.style.maxHeight = "0px";
    });

    var onEnd = function (ev) {
      if (ev.propertyName !== "max-height") return;

      panel.hidden = true;
      panel.removeEventListener("transitionend", onEnd);
    };

    panel.addEventListener("transitionend", onEnd);
  }

  /* ========== SWYM RE-INIT ========== */
  function triggerSwymReinit(sectionEl) {
    if (!sectionEl) return;

    var sectionId = sectionEl.getAttribute("data-section-id");

    var selector = sectionId
      ? "#shopify-section-" + sectionId
      : '[data-section-type="mh-cnm-constraint-collection"]';

    window.__mhSwymLastSelector = selector;

    if (
      window._swat &&
      typeof window._swat.initializeActionButtons === "function"
    ) {
      try {
        window._swat.initializeActionButtons(selector);
      } catch (e) {}
    }

    document.dispatchEvent(
      new CustomEvent("swym:collections-loaded", {
        detail: {
          selector: selector
        }
      })
    );
  }

  
  /* ========== SPURIT PREORDER RE-INIT ========== */

  function triggerSpuritReinit(sectionEl) {
    if (!sectionEl) return;

    // Scripts parsed from fetched HTML do not execute
    // automatically when the section is replaced.
    // Re-run only the SpurIT product registration scripts.

    sectionEl
      .querySelectorAll(".mh-cnm-prd-card__atc script")
      .forEach(function (oldScript) {

        var code = oldScript.textContent || "";

        if (code.indexOf("Spurit.Preorder2") === -1) {
          return;
        }

        var newScript = document.createElement("script");

        newScript.textContent = code;

        oldScript.parentNode.replaceChild(
          newScript,
          oldScript
        );

      });
  }

  /* ========== MENU ACCORDION ========== */
  function initMenuAccordion(sectionEl) {
    if (!sectionEl) return;

    var layout = sectionEl.getAttribute("data-filter-layout") || "sidebar";
    var isDrawerAll = layout === "drawer";
    var isDesktopSidebar = !isDrawerAll && window.innerWidth > 990;

    var menuBlocks = sectionEl.querySelectorAll(".mh-cnm-menu-accordion");

    menuBlocks.forEach(function (block) {
      var titleToggle = block.querySelector(
        ".mh-cnm-menu-accordion__title-toggle"
      );
      var itemsWrap = block.querySelector(".mh-cnm-menu-accordion__items");

      if (!titleToggle || !itemsWrap) return;

      itemsWrap.hidden = false;
      itemsWrap.style.maxHeight = "none";
      titleToggle.setAttribute("aria-expanded", "true");

      titleToggle.addEventListener("click", function (e) {
        e.preventDefault();

        var isOpen = titleToggle.getAttribute("aria-expanded") === "true";

        if (isOpen) {
          titleToggle.setAttribute("aria-expanded", "false");
          slideUp(itemsWrap);
        } else {
          titleToggle.setAttribute("aria-expanded", "true");
          slideDown(itemsWrap);
        }
      });
    });

    var items = sectionEl.querySelectorAll(".mh-cnm-menu-accordion__item");

    items.forEach(function (item) {
      var trigger = item.querySelector(
        '.mh-cnm-menu-accordion__summary-toggle[data-mh-cnm-accordion-trigger="menu-parent"]'
      );
      var panel = item.querySelector(".mh-cnm-menu-accordion__panel");

      if (!trigger || !panel) return;

      panel.hidden = true;
      panel.style.maxHeight = "0px";
      item.classList.remove("is-open");

      trigger.addEventListener("click", function (e) {
        e.preventDefault();

        var isOpen = item.classList.contains("is-open");

        if (isOpen) {
          item.classList.remove("is-open");
          slideUp(panel);
        } else {
          if (!isDrawerAll && window.innerWidth > 990) {
            items.forEach(function (other) {
              if (other === item) return;

              other.classList.remove("is-open");

              var otherPanel = other.querySelector(
                ".mh-cnm-menu-accordion__panel"
              );

              if (otherPanel) {
                otherPanel.hidden = true;
                otherPanel.style.maxHeight = "0px";
              }
            });
          }

          item.classList.add("is-open");
          slideDown(panel);
        }
      });
    });

    var toggles = sectionEl.querySelectorAll(
      ".mh-cnm-menu-accordion__child-toggle"
    );

    toggles.forEach(function (btn) {
      var li = btn.closest(".mh-cnm-menu-accordion__child");
      if (!li) return;

      var panel = li.querySelector(
        ".mh-cnm-menu-accordion__grandchildren-panel"
      );

      if (!panel) return;

      panel.hidden = true;
      panel.style.maxHeight = "0px";
      btn.setAttribute("aria-expanded", "false");

      btn.addEventListener("click", function (e) {
        e.preventDefault();

        var isOpen = btn.getAttribute("aria-expanded") === "true";

        if (isOpen) {
          btn.setAttribute("aria-expanded", "false");
          slideUp(panel);
        } else {
          btn.setAttribute("aria-expanded", "true");
          slideDown(panel);
        }
      });
    });

    if (isDesktopSidebar && items.length) {
      var firstItem = items[0];
      var firstPanel = firstItem.querySelector(".mh-cnm-menu-accordion__panel");

      if (firstPanel) {
        firstItem.classList.add("is-open");
        firstPanel.hidden = false;
        firstPanel.style.maxHeight = "none";
      }
    }
  }

  /* ========== CONSTRAINT ACCORDIONS ========== */
  function initConstraintAccordions(sectionEl) {
    if (!sectionEl) return;

    var layout = sectionEl.getAttribute("data-filter-layout") || "sidebar";
    var isDrawerAll = layout === "drawer";
    var isDesktopSidebar = !isDrawerAll && window.innerWidth > 990;

    var blocks = sectionEl.querySelectorAll(".mh-cnm-constraint-filter");

    blocks.forEach(function (block) {
      var trigger = block.querySelector(
        '.mh-cnm-constraint-filter__summary-toggle[data-mh-cnm-accordion-trigger="constraint"]'
      );
      var panel = block.querySelector(".mh-cnm-constraint-filter__panel");

      if (!trigger || !panel) return;

      if (block.classList.contains("is-open")) {
        panel.hidden = false;
        panel.style.maxHeight = "none";
      } else {
        panel.hidden = true;
        panel.style.maxHeight = "0px";
        block.classList.remove("is-open");
      }

      trigger.addEventListener("click", function (e) {
        e.preventDefault();

        var isOpen = block.classList.contains("is-open");

        if (isOpen) {
          block.classList.remove("is-open");
          slideUp(panel);
        } else {
          if (!isDrawerAll && window.innerWidth > 990) {
            blocks.forEach(function (other) {
              if (other === block) return;

              other.classList.remove("is-open");

              var otherPanel = other.querySelector(
                ".mh-cnm-constraint-filter__panel"
              );

              if (otherPanel) {
                otherPanel.hidden = true;
                otherPanel.style.maxHeight = "0px";
              }
            });
          }

          block.classList.add("is-open");
          slideDown(panel);
        }
      });
    });

    if (isDesktopSidebar && blocks.length) {
      var firstBlock = blocks[0];
      var firstPanel = firstBlock.querySelector(
        ".mh-cnm-constraint-filter__panel"
      );

      if (firstPanel) {
        firstBlock.classList.add("is-open");
        firstPanel.hidden = false;
        firstPanel.style.maxHeight = "none";
      }
    }
  }

  /* ========== FILTER DRAWER ========== */
  function initFilterDrawerControls(sectionEl) {
    if (!sectionEl) return;

    var layout = sectionEl.getAttribute("data-filter-layout") || "sidebar";
    var drawerWrap = sectionEl.querySelector(".mh-cnm-filters-drawer");
    var overlay = sectionEl.querySelector(".mh-cnm-filters-drawer__overlay");
    var sidebar = sectionEl.querySelector(".mh-cnm-collection-sidebar");
    var toggles = sectionEl.querySelectorAll(".mh-cnm-filter-toggle");
    var closeBtn = sectionEl.querySelector(".mh-cnm-filters-drawer__close");

    if (!sidebar || !drawerWrap || !overlay || !toggles.length) return;

    function shouldUseDrawer() {
      if (layout === "drawer") return true;
      return window.innerWidth <= 990;
    }

    function openDrawer() {
      if (!shouldUseDrawer()) return;
      sectionEl.classList.add("mh-cnm-filters-open");
    }

    function closeDrawer() {
      sectionEl.classList.remove("mh-cnm-filters-open");
    }

    toggles.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();

        if (!shouldUseDrawer()) return;

        if (sectionEl.classList.contains("mh-cnm-filters-open")) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    });

    overlay.addEventListener("click", function (e) {
      e.preventDefault();
      closeDrawer();
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", function (e) {
        e.preventDefault();
        closeDrawer();
      });
    }

    document.addEventListener("keyup", function (e) {
      if (e.key === "Escape") {
        closeDrawer();
      }
    });

    if (!shouldUseDrawer()) {
      sectionEl.classList.remove("mh-cnm-filters-open");
    }
  }

  /* ========== CONSTRAINT FILTERS + SORT + VIEW + GRID/LIST ========== */
  function initConstraintFiltersForSection(sectionEl) {
    var sectionId = sectionEl.getAttribute("data-section-id");
    var collectionUrl = sectionEl.getAttribute("data-collection-url");

    if (!sectionId || !collectionUrl) return;

    var gridContainer = sectionEl.querySelector("#ProductGridContainer");
    if (!gridContainer) return;

    var checkboxes = sectionEl.querySelectorAll(
      ".mh-cnm-constraint-filter__checkbox"
    );
    var sortSelect = sectionEl.querySelector(".mh-cnm-sort-by-select");
    var viewButtons = sectionEl.querySelectorAll(".mh-cnm-view-toggle");
    var productsViewSelects = sectionEl.querySelectorAll(
      ".mh-cnm-products-view-count-select"
    );

    initConstraintAccordions(sectionEl);

    if (
      !checkboxes.length &&
      !sortSelect &&
      !viewButtons.length &&
      !productsViewSelects.length
    ) {
      return;
    }

    try {
      var existingConstraint = Shopify.queryParams.constraint || null;

      if (existingConstraint) {
        var selectedSlugs = existingConstraint.split("+");

        checkboxes.forEach(function (input) {
          if (selectedSlugs.indexOf(input.value) !== -1) {
            input.checked = true;
          }
        });
      }
    } catch (e) {
      console.warn("Constraint pre-check failed", e);
    }

    function syncViewDropdown(value) {
      if (!productsViewSelects.length) return;

      var currentView = value || new URL(window.location.href).searchParams.get("view");

      if (!currentView) {
        currentView = "24";
      }

      productsViewSelects.forEach(function (select) {
        select.value = currentView;
      });
    }

    function getSelectedConstraints() {
      var values = [];

      checkboxes.forEach(function (input) {
        if (input.checked) {
          values.push(input.value);
        }
      });

      return values;
    }

    function buildNavigationUrlWithConstraints() {
      var selected = getSelectedConstraints();

      if (selected.length) {
        Shopify.queryParams.constraint = selected.join("+");
      } else {
        delete Shopify.queryParams.constraint;
      }

      delete Shopify.queryParams.page;

      var urlObj = new URL(collectionUrl, window.location.origin);
      var qs = buildQueryString(Shopify.queryParams);

      return urlObj.origin + urlObj.pathname + (qs ? "?" + qs : "");
    }

    function buildNavigationUrlWithSort(sortValue) {
      if (sortValue) {
        Shopify.queryParams.sort_by = sortValue;
      } else {
        delete Shopify.queryParams.sort_by;
      }

      delete Shopify.queryParams.page;

      var urlObj = new URL(collectionUrl, window.location.origin);
      var qs = buildQueryString(Shopify.queryParams);

      return urlObj.origin + urlObj.pathname + (qs ? "?" + qs : "");
    }

    function buildNavigationUrlWithTemplateView(viewValue) {
      var urlObj = new URL(window.location.href);

      urlObj.searchParams.delete("page");
      urlObj.searchParams.delete("section_id");

      if (viewValue && viewValue !== "24") {
        urlObj.searchParams.set("view", viewValue);
        Shopify.queryParams.view = viewValue;
      } else {
        urlObj.searchParams.delete("view");
        delete Shopify.queryParams.view;
      }

      delete Shopify.queryParams.page;

      return urlObj.pathname + (urlObj.search ? urlObj.search : "");
    }

    function showAllFilterOptions() {
      var blocks = sectionEl.querySelectorAll(".mh-cnm-constraint-filter");

      blocks.forEach(function (block) {
        block.style.display = "";

        block
          .querySelectorAll(".mh-cnm-constraint-filter__item")
          .forEach(function (item) {
            var input = item.querySelector('input[type="checkbox"]');
            var countEl = item.querySelector(".mh-cnm-constraint-filter__count");

            if (!input) return;

            item.hidden = false;
            item.classList.remove("mh-cnm-constraint-filter__item--disabled");
            input.disabled = false;

            if (countEl) {
              countEl.hidden = true;
              countEl.textContent = "";
            }
          });
      });
    }

    function updateClearButtons() {
      var blocks = sectionEl.querySelectorAll(".mh-cnm-constraint-filter");

      blocks.forEach(function (block) {
        var clearBtn = block.querySelector(".mh-cnm-constraint-filter__clear");

        if (!clearBtn) return;

        var anyChecked = !!block.querySelector(
          ".mh-cnm-constraint-filter__checkbox:checked"
        );

        clearBtn.hidden = !anyChecked;
      });
    }

    function applyGlobalAvailableToFilters(countMap) {
      var blocks = sectionEl.querySelectorAll(".mh-cnm-constraint-filter");

      if (!blocks.length) return;

      if (!countMap || countMap.size === 0) {
        showAllFilterOptions();
        updateClearButtons();
        return;
      }

      blocks.forEach(function (block) {
        var items = block.querySelectorAll(".mh-cnm-constraint-filter__item");
        var blockHasVisible = false;

        items.forEach(function (item) {
          var input = item.querySelector('input[type="checkbox"]');
          var countEl = item.querySelector(".mh-cnm-constraint-filter__count");

          if (!input) return;

          var value = input.value;
          var isChecked = input.checked;
          var count = countMap.get(value) || 0;
          var shouldShow = isChecked || count > 0;

          if (shouldShow) {
            item.hidden = false;
            item.classList.remove("mh-cnm-constraint-filter__item--disabled");
            input.disabled = false;
            blockHasVisible = true;

            if (countEl) {
              countEl.hidden = false;
              countEl.textContent = "(" + count + ")";
            }
          } else {
            item.hidden = true;
            item.classList.add("mh-cnm-constraint-filter__item--disabled");
            input.disabled = true;

            if (countEl) {
              countEl.hidden = true;
              countEl.textContent = "";
            }
          }
        });

        block.style.display = blockHasVisible ? "" : "none";
      });

      updateClearButtons();
    }

    function computeAndApplyGlobalTrim() {
      var emptyState = sectionEl.querySelector(".mh-cnm-collection-empty");

      if (emptyState) {
        showAllFilterOptions();
        updateClearButtons();
        return;
      }

      var gridContainer = sectionEl.querySelector("#ProductGridContainer");

      if (!gridContainer) {
        showAllFilterOptions();
        updateClearButtons();
        return;
      }

      var totalPagesAttr = gridContainer.getAttribute("data-total-pages") || "1";
      var totalPages = parseInt(totalPagesAttr, 10);

      if (!totalPages || totalPages < 1) {
        totalPages = 1;
      }

      var basePath = window.location.pathname;
      var baseParams = new URLSearchParams(window.location.search);

      baseParams.delete("page");
      baseParams.delete("section_id");

      var counts = new Map();

      function collectFromHtml(html) {
        try {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          var sec =
            doc.querySelector(
              '[data-section-id="' +
                sectionId +
                '"][data-section-type="mh-cnm-constraint-collection"]'
            ) ||
            doc.querySelector(
              '[data-section-type="mh-cnm-constraint-collection"]'
            );

          if (!sec) return;

          var productEls = sec.querySelectorAll(
            ".mh-cnm-product-grid__item[data-constraint-tags]"
          );

          productEls.forEach(function (el) {
            var raw = el.getAttribute("data-constraint-tags") || "";
            if (!raw) return;

            var seenForProduct = new Set();

            raw.split(",").forEach(function (slug) {
              slug = slug.trim();

              if (!slug || seenForProduct.has(slug)) return;

              seenForProduct.add(slug);
              counts.set(slug, (counts.get(slug) || 0) + 1);
            });
          });
        } catch (e) {
          console.warn("Error parsing section HTML for constraint tag counts", e);
        }
      }

      var fetches = [];

      for (var p = 1; p <= totalPages; p++) {
        var pageParams = new URLSearchParams(baseParams.toString());

        pageParams.set("page", String(p));
        pageParams.set("section_id", sectionId);

        var url = basePath + "?" + pageParams.toString().replace(/%2B/g, "+");

        fetches.push(
          fetch(url)
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              collectFromHtml(html);
            })
            .catch(function (err) {
              console.warn("Constraint multi-page fetch failed", err);
            })
        );
      }

      Promise.all(fetches).then(function () {
        applyGlobalAvailableToFilters(counts);
      });
    }

    function ajaxReplaceSection(url) {
      var currentSectionId = sectionEl.getAttribute("data-section-id");
      var fetchUrl = url;

      fetchUrl +=
        (fetchUrl.indexOf("?") > -1 ? "&" : "?") +
        "section_id=" +
        encodeURIComponent(currentSectionId);

      sectionEl.classList.add("mh-cnm-constraint-loading");

      fetch(fetchUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          var newSection =
            doc.querySelector(
              '[data-section-id="' +
                currentSectionId +
                '"][data-section-type="mh-cnm-constraint-collection"]'
            ) ||
            doc.querySelector(
              '[data-section-type="mh-cnm-constraint-collection"]'
            );

          var currentSection = document.querySelector(
            '[data-section-id="' +
              currentSectionId +
              '"][data-section-type="mh-cnm-constraint-collection"]'
          );

          if (newSection && currentSection && currentSection.parentNode) {
            currentSection.parentNode.replaceChild(newSection, currentSection);
            sectionEl = newSection;
          }

          history.replaceState({}, "", url);

          initMenuAccordion(sectionEl);
          initConstraintFiltersForSection(sectionEl);
          initFilterDrawerControls(sectionEl);
          triggerSpuritReinit(sectionEl);
          triggerSwymReinit(sectionEl);
        })
        .catch(function (error) {
          console.error("Constraint/sort/filter AJAX error", error);
        })
        .finally(function () {
          var sec = document.querySelector(
            '[data-section-type="mh-cnm-constraint-collection"]'
          );

          if (sec) {
            sec.classList.remove("mh-cnm-constraint-loading");
          }
        });
    }

    function ajaxReplaceFullTemplate(url) {
      sectionEl.classList.add("mh-cnm-constraint-loading");

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          var newSection = doc.querySelector(
            '[data-section-type="mh-cnm-constraint-collection"]'
          );

          var currentSection = document.querySelector(
            '[data-section-type="mh-cnm-constraint-collection"]'
          );

          if (newSection && currentSection && currentSection.parentNode) {
            currentSection.parentNode.replaceChild(newSection, currentSection);
            sectionEl = newSection;
          }

          history.replaceState({}, "", url);

          initMenuAccordion(sectionEl);
          initConstraintFiltersForSection(sectionEl);
          initFilterDrawerControls(sectionEl);
          triggerSpuritReinit(sectionEl);
          triggerSwymReinit(sectionEl);
        })
        .catch(function (error) {
          console.error("Template view AJAX error", error);
          window.location.href = url;
        })
        .finally(function () {
          var sec = document.querySelector(
            '[data-section-type="mh-cnm-constraint-collection"]'
          );

          if (sec) {
            sec.classList.remove("mh-cnm-constraint-loading");
          }
        });
    }

    function handleFilterChange() {
      var url = buildNavigationUrlWithConstraints();
      ajaxReplaceSection(url);
    }

    function handleSortChange(event) {
      var value = event.target.value || "";
      var url = buildNavigationUrlWithSort(value);
      ajaxReplaceSection(url);
    }

    function handleTemplateViewChange(event) {
      var value = event.target.value || "24";

      // Sync top + pagination dropdown immediately
      syncViewDropdown(value);

      var url = buildNavigationUrlWithTemplateView(value);

      ajaxReplaceFullTemplate(url);
    }

    function applyView(view) {
      var grid = sectionEl.querySelector("#product-grid");
      if (!grid) return;

      viewButtons.forEach(function (btn) {
        if (btn.getAttribute("data-view") === view) {
          btn.classList.add("view-active");
        } else {
          btn.classList.remove("view-active");
        }
      });

      grid.classList.remove(
        "mh-cnm-product-grid-view",
        "mh-cnm-product-list-view"
      );

      if (view === "list") {
        grid.classList.add("mh-cnm-product-list-view");
      } else {
        grid.classList.add("mh-cnm-product-grid-view");
      }
    }

    checkboxes.forEach(function (input) {
      input.addEventListener("change", handleFilterChange);
    });

    if (sortSelect) {
      sortSelect.addEventListener("change", handleSortChange);
    }

    if (productsViewSelects.length) {
      syncViewDropdown();

      productsViewSelects.forEach(function (select) {
        select.addEventListener("change", handleTemplateViewChange);
      });
    }

    if (viewButtons.length) {
      viewButtons.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();

          var view = btn.getAttribute("data-view") || "grid";
          applyView(view);
        });
      });

      applyView("grid");
    }

    var clearButtons = sectionEl.querySelectorAll(
      ".mh-cnm-constraint-filter__clear"
    );

    clearButtons.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();

        var block = e.currentTarget.closest(".mh-cnm-constraint-filter");
        if (!block) return;

        var boxList = block.querySelectorAll(
          ".mh-cnm-constraint-filter__checkbox"
        );

        boxList.forEach(function (cb) {
          cb.checked = false;
        });

        handleFilterChange();
      });
    });

    computeAndApplyGlobalTrim();
  }

  function initConstraintCollectionSection(sectionEl) {
    if (!sectionEl) return;

    initMenuAccordion(sectionEl);
    initConstraintFiltersForSection(sectionEl);
    initFilterDrawerControls(sectionEl);
  }

  function initAllConstraintSections() {
    var sections = document.querySelectorAll(
      '[data-section-type="mh-cnm-constraint-collection"]'
    );

    sections.forEach(initConstraintCollectionSection);
  }

  document.addEventListener("DOMContentLoaded", initAllConstraintSections);

  document.addEventListener("shopify:section:load", function (event) {
    var selector =
      '[data-section-id="' +
      event.detail.sectionId +
      '"][data-section-type="mh-cnm-constraint-collection"]';

    var sectionEl = document.querySelector(selector);

    if (sectionEl) {
      initConstraintCollectionSection(sectionEl);
    }
  });
})();